// Simple global event bus to open the Contact Modal from anywhere.
const EVT = "edge:openContact";

export function openContactModal() {
  window.dispatchEvent(new CustomEvent(EVT));
}

export function onOpenContactModal(handler) {
  window.addEventListener(EVT, handler);
  return () => window.removeEventListener(EVT, handler);
}
